jQuery(function () {
    var myOffside = offside("#mobileMenu", {
        slidingElementsSelector: "body",
        buttonsSelector: ".menu-toggle, .offcanvas-close, .offcanvas-overlay",
        beforeOpen: function () {
            $(".offcanvas-overlay").fadeIn();
        },
        beforeClose: function () {
            $(".offcanvas-overlay").fadeOut();
        },
    });

    $(".header-wrap").sticky({
        topSpacing: 0,
        zIndex: 50,
    });

    $(".brand-filter-list ul").sticky({
        topSpacing: 140,
        zIndex: 50,
    });

    $(".mega-menu-left").append($(".mega-submenu-wrap"));

    $(".cart-toggle").on("click", function () {
        $(".cart-dropdown").toggleClass("show");
    });

    $(".cart-close").on("click", function () {
        $(".cart-dropdown").removeClass("show");
    });

    $(".back-to-top").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 2000);
    });

    if ($(window).width() < 1024.98) {
        $(".search-toggle").on("click", function () {
            $(".search-wrapper").fadeToggle("");
        });

        $(document).on("click", function (e) {
            if (
                $(".search-toggle").has(e.target).length === 0 &&
                $(".search-wrapper").has(e.target).length === 0
            ) {
                $(".search-wrapper").fadeOut("");
            }
        });

        $(".sidenav-menu-heading").on("click", function () {
            $(".sidenav-menu").slideToggle("");
        });

        productDetailRelatedSlide();
    }

    if ($(".news-detail-page").length > 0) {
        $(".news-section .container").append($(".news-detail-other"));
        window.dispatchEvent(new Event("resize"));
    }

    $.fancybox.defaults.parentEl = "form";

    megaMenu();
    sideProductNav();
    productDetailSlide();
    dealCountdown();
    flashSaleCountdown();
    // spinInput();
    productSlider();
    collapseComponent();
    categoryNavSlider();
    productTabs();
    productPriceFilter();

    $(".brand-filter-list a").click(function (e) {
        e.preventDefault();
        scrollToElement($(this).attr("data-id"), 2000);
    });

    $(document).on("click", function (e) {
        if (
            $(".cart-dropdown").has(e.target).length === 0 &&
            $(".cart-toggle").has(e.target).length === 0 &&
            $(".cart-close").has(e.target).length === 0
        ) {
            $(".cart-dropdown").removeClass("show");
        }

        if (
            $(".productsearchbox").has(e.target).length === 0 &&
            $(".suggestsearch").has(e.target).length === 0
        ) {
            $(".suggestsearch").remove();
            $(".searchinput").val("");
        }

        if (
            $(".product-menu-toggle-wrap").has(e.target).length === 0 &&
            $(".mega-menu-wrap").has(e.target).length === 0
        ) {
            $(".mega-menu-wrap").fadeOut("");
            $(".product-menu-toggle").removeClass("active");
        }
    });

    if ($(".account ul li").length == 0) {
        $(".account ul").remove();
    }

    $(".product-detail-attr .tab-content .expand-content").each(function () {
        let defaultHeight = $(this).innerHeight();
        let maxHeight = 500;
        let _this = $(this);
        _this.css({
            maxHeight: maxHeight,
        });
        _this.next().on("click", function (e) {
            e.preventDefault();
            var newHeight = 0;
            if (_this.hasClass("active")) {
                newHeight = maxHeight;
                _this.removeClass("active");
            } else {
                newHeight = defaultHeight;
                _this.addClass("active");
            }
            _this.animate(
                {
                    "max-height": newHeight,
                },
                500
            );
            $(this).toggleHtml(
                `Xem thêm <em class="fal fa-chevron-down"></em>`,
                `Rút gọn <em class="fal fa-chevron-up"></em>`
            );
        });
    });

    $(".product-detail-attr .tab-content .expand-content").each(function () {
        if ($(this).height() === 500) {
            $(this).next().show();
        } else {
            $(this).next().hide();
        }
    });

    $(".product-detail-attr .tabs").tabslet({});

    // $(".toggle-location").on("click", function (e) {
    //     e.preventDefault();
    //     $(".location-list").fadeToggle();
    // });

    $(document).on("click", ".has-sub .toggle", function () {
        $(this).parent().next().slideToggle();
        $(this).toggleClass("fa-chevron-down fa-chevron-up");
    });

    $(".commentpanel").appendTo($(".product-detail-comment-wrap"));
});

$.fn.extend({
    toggleText: function (a, b) {
        return this.text(this.text() == b ? a : b);
    },
});

$.fn.extend({
    toggleHtml: function (a, b) {
        return this.html(this.html() == b ? a : b);
    },
});

function collapseComponent() {
    $(document).on("click", ".collapse-trigger", function () {
        $(this).next().slideToggle();
        $(this).toggleClass("active");
        return false;
    });
}

const menuTopMapping = new MappingListener({
    selector: ".top-nav-wrap",
    mobileWrapper: ".offcanvas-wrap",
    mobileMethod: "appendTo",
    desktopWrapper: ".header-top",
    desktopMethod: "appendTo",
    breakpoint: 1024.98,
}).watch();

function parseDate(date) {
    var dateInit = date;
    var datearray = dateInit.split(" ");
    var dateNeedFormat = datearray[0];
    var dateNeedFormatArray = dateNeedFormat.split(/\//);
    var dateAfterFormat = [
        dateNeedFormatArray[1],
        dateNeedFormatArray[0],
        dateNeedFormatArray[2],
    ].join("/");
    return [dateAfterFormat, datearray[1]].join(" ");
}

var scrollToElement = function (el, ms) {
    var speed = ms ? ms : 2000;
    $("html,body").animate(
        {
            scrollTop: $(el).offset().top - $("header").height(),
        },
        speed
    );
};

function megaMenu() {
    $(".product-menu-toggle").on("click", function () {
        $(this).toggleClass("active");
        $(".mega-menu-wrap").fadeToggle();
    });

    if ($(window).width() > 1024.98) {
        $(".link-lv-1").mouseenter(function () {
            var idHover = $(this).data("index");
            $(".product-category-lv-2-list-wrap").hide();
            $(
                `.product-category-lv-2-list-wrap[data-index="${idHover}"]`
            ).show();
        });

        $(".link-lv-2").mouseenter(function () {
            var idHover = $(this).data("index");
            $(".product-category-lv-3").hide();
            $(`.product-category-lv-3[data-index="${idHover}"]`).show();
        });
    }
}

function sideProductNav() {
    $(".filter-toggle").on("click", function (e) {
        e.preventDefault();
        $(".product-filter-wrap").toggleClass("show");
        $(".overlay").fadeIn();
        $("body").addClass("overflow-hidden");
    });

    $(".overlay, .close-filter").on("click", function (e) {
        e.preventDefault();
        $(".product-filter-wrap").removeClass("show");
        $(".overlay").fadeOut();
        $("body").removeClass("overflow-hidden");
    });
}

function dealCountdown() {
    $(".deal-countdown").each(function () {
        var date = $(this).data("countdown");
        var formatDate = parseDate(date);
        $(this).countdown(formatDate, function (event) {
            $(this).html(
                event.strftime(
                    "<div class='count'><span class='number'>%-D</span><span class='separator'>:</span></div>" +
                        "<div class='count'><span class='number'>%H</span><span class='separator'>:</span></div>" +
                        "<div class='count'><span class='number'>%M</span><span class='separator'>:</span></div>" +
                        "<div class='count'><span class='number'>%S</span></div>"
                )
            );
        });
    });
}

function flashSaleCountdown() {
    $(".product-deadline").each(function () {
        var date = $(this).data("countdown");
        var formatDate = parseDate(date);
        $(this).countdown(formatDate, function (event) {
            $(this).html(
                event.strftime(
                    "<div class='count'><span class='number'>%-D</span><span class='unit'>Ngày</span></div>" +
                        "<div class='count'><span class='number'>%H</span><span class='unit'>Giờ</span></div>" +
                        "<div class='count'><span class='number'>%M</span><span class='unit'>Phút</span></div>" +
                        "<div class='count'><span class='number'>%S</span><span class='unit'>Giây</span></div>"
                )
            );
        });
    });
}

function productTabs() {
    $(".product-category-item .tab-content:not('.active')").hide();
    $(".tab-toggle").on("click", function (e) {
        e.preventDefault();
        var index = $(this).data("tab");
        $(this).parent().siblings().children().removeClass("active");
        $(this).addClass("active");
        $(`.tab-content[data-tab="${index}"]`)
            .siblings()
            .hide()
            .removeClass("active");
        $(`.tab-content[data-tab="${index}"]`).addClass("active");
    });
}

const bannerSlider = new Swiper(".banner-slider .swiper-container", {
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },
    loop: true,
    speed: 1300,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".banner-slider .swiper-pagination",
        clickable: true,
    },
    navigation: {
        prevEl: ".banner-slider .swiper-prev",
        nextEl: ".banner-slider .swiper-next",
    },
});

function productDetailSlide() {
    var productDetailThumbnail = new Swiper(
        ".product-detail-thumbnail .swiper-container",
        {
            slidesPerView: 4,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            breakpoints: {
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 5,
                },
            },
        }
    );

    var productDetailImages = new Swiper(
        ".product-detail-images .swiper-container",
        {
            observer: true,
            observeParents: true,
            thumbs: {
                swiper: productDetailThumbnail,
            },
            navigation: {
                prevEl: ".product-detail-thumbnail .swiper-prev",
                nextEl: ".product-detail-thumbnail .swiper-next",
            },
        }
    );
}

function productDetailRelatedSlide() {
    var productDetailRelated = new Swiper(
        ".product-detail-related .swiper-container",
        {
            slidesPerView: 2.75,
            spaceBetween: 15,
            freeMode: true,
            breakpoints: {
                576: {
                    slidesPerView: 1.55,
                    spaceBetween: 10,
                },
            },
        }
    );
}

var newsSlider = new Swiper(".news-slider .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
        prevEl: ".news-slider .swiper-prev",
        nextEl: ".news-slider .swiper-next",
    },
    breakpoints: {
        1024: {
            slidesPerView: 2.75,
            spaceBetween: 15,
            freeMode: true,
        },
        768: {
            slidesPerView: 2.75,
            spaceBetween: 10,
            freeMode: true,
        },
        576: {
            slidesPerView: 1.5,
            spaceBetween: 10,
            freeMode: true,
        },
    },
});

var brandSlider = new Swiper(".brand-slider .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 40,
    navigation: {
        prevEl: ".brand-slider .swiper-prev",
        nextEl: ".brand-slider .swiper-next",
    },
    breakpoints: {
        1024: {
            slidesPerView: 3.75,
            spaceBetween: 15,
            freeMode: true,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 10,
            freeMode: true,
        },
        576: {
            slidesPerView: 2.5,
            spaceBetween: 10,
            freeMode: true,
        },
    },
});

var flashsaleSlider = new Swiper(".flashsale-slider .swiper-container", {
    slidesPerView: 6,
    spaceBetween: 30,
    scrollbar: {
        el: ".flashsale-slider .swiper-scrollbar",
        draggable: true,
    },
    breakpoints: {
        1440: {
            slidesPerView: 5,
            spaceBetween: 30,
        },
        1280: {
            slidesPerView: 4,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3.5,
            spaceBetween: 15,
            freeMode: true,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 10,
            freeMode: true,
        },
        576: {
            slidesPerView: 1.5,
            spaceBetween: 10,
            freeMode: true,
        },
    },
});

function productSlider() {
    $(".product-slider").each(function (index) {
        var $this = $(this);
        if ($(this).data("slides") !== undefined) {
            var initSlide = $(this).data("slides");
        } else {
            var initSlide = 4;
        }
        $this.addClass("product-slider-" + index);
        $this.find(".swiper-prev").addClass("product-slider-prev-" + index);
        $this.find(".swiper-next").addClass("product-slider-next-" + index);

        var productSlider = new Swiper(
            ".product-slider-" + index + " .swiper-container",
            {
                slidesPerView: initSlide,
                spaceBetween: 30,
                navigation: {
                    prevEl: ".product-slider-prev-" + index,
                    nextEl: ".product-slider-next-" + index,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3.75,
                        spaceBetween: 15,
                        freeMode: true,
                    },
                    768: {
                        slidesPerView: 2.75,
                        spaceBetween: 10,
                        freeMode: true,
                    },
                    576: {
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                        freeMode: true,
                    },
                },
            }
        );
    });
}

function categoryNavSlider() {
    $(".category-submenu-slider").each(function (index) {
        var $this = $(this);
        $this.addClass("category-submenu-" + index);
        $this.find(".swiper-next").addClass("category-submenu-next-" + index);
        $this.find(".swiper-prev").addClass("category-submenu-prev-" + index);

        var productSlider = new Swiper(
            ".category-submenu-" + index + " .swiper-container",
            {
                slidesPerView: "auto",
                spaceBetween: 12,
                freeMode: true,
                navigation: {
                    prevEl: ".category-submenu-prev-" + index,
                    nextEl: ".category-submenu-next-" + index,
                },
            }
        );
    });
}

const promoteProgramSlider = new Swiper(
    ".promote-program-slider .swiper-container",
    {
        spaceBetween: 10,
        slidesPerView: 8,
        breakpoints: {
            1024: {
                slidesPerView: 4.5,
                autoplay: {
                    delay: 1300,
                },
                freeMode: true,
            },
            768: {
                slidesPerView: 3.5,
                autoplay: {
                    delay: 1300,
                },
                freeMode: true,
            },
            576: {
                slidesPerView: 2.5,
                autoplay: {
                    delay: 1300,
                },
                freeMode: true,
            },
        },
    }
);

function spinInput() {
    $(".btn-spin").click(function () {
        var $button = $(this);
        var type = $(this).data("spin");
        var oldValue = $button.parent().find("input").val();

        if (type == "inc") {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            if (oldValue > 0) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }
        }
        $button.parent().find("input").val(newVal);
        //   AjaxCart.updatecart();
    });
}

function productPriceFilter() {
    var maxPrice = parseInt($(".price-price-slider").data("max"));
    $(".price-price-slider").slider({
        range: true,
        min: 0,
        max: maxPrice,
        values: [0, maxPrice],
        step: 50000,
        slide: function (event, ui) {
            $(".price-filter-text-min").text(
                getNumberWithCommas(ui.values[0]) + " đ"
            );
            $(".price-filter-text-max").text(
                getNumberWithCommas(ui.values[1]) + " đ"
            );
        },
        change: function (event, ui) {},
    });
}

function getNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
